import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sun, Zap, ArrowRight } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { useContent, resolveImg } from "@/lib/content";

const EASE = [0.16, 1, 0.3, 1];

export default function GatewayPage() {
  useSeo(
    "HB Solar | Energia Solar e Recarga de Veículos Elétricos — Bahia",
    "Escolha sua solução: energia solar fotovoltaica com a HB Solar ou infraestrutura de recarga para veículos elétricos com a HB Charger. Jequié, Bahia."
  );
  const { textos, imagens } = useContent();

  return (
    <section data-testid="gateway-section" className="relative min-h-screen bg-[#0B192C] pt-[76px] flex flex-col">
      <div className="relative flex-1 grid lg:grid-cols-2">
        <Link to="/energia-solar" data-testid="gateway-solar-option" className="group relative overflow-hidden min-h-[44vh] lg:min-h-0">
          <img
            src={resolveImg(imagens.gatewaySolar)}
            alt="Energia solar fotovoltaica HB Solar"
            className="absolute inset-0 h-full w-full object-cover opacity-50 transition-all duration-700 group-hover:opacity-60 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0B192C]/85 to-[#0B192C]/40" />
          <motion.div
            initial={{ opacity: 0, y: 32 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
            className="relative h-full flex flex-col justify-center px-8 sm:px-14 lg:px-16 py-16"
          >
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-400 text-[#0B192C] transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-6">
              <Sun className="h-7 w-7" />
            </span>
            <p className="mt-7 text-xs font-bold uppercase tracking-[0.26em] text-amber-400">HB Solar</p>
            <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              {textos.gatewaySolarTitulo}
            </h1>
            <p className="mt-4 max-w-md text-base sm:text-lg leading-relaxed text-slate-300">
              {textos.gatewaySolarTexto}
            </p>
            <span className="mt-8 inline-flex w-fit items-center gap-2.5 rounded-full bg-amber-400 px-7 py-4 font-extrabold text-[#0B192C] transition-all duration-300 group-hover:bg-amber-300 group-hover:gap-4">
              Quero economizar na conta de luz
              <ArrowRight className="h-5 w-5" />
            </span>
          </motion.div>
        </Link>

        <Link to="/hb-charger" data-testid="gateway-charger-option" className="group relative overflow-hidden min-h-[44vh] lg:min-h-0 border-t lg:border-t-0 lg:border-l border-white/10">
          <img
            src={resolveImg(imagens.gatewayCharger)}
            alt="Carregadores para veículos elétricos HB Charger"
            className="absolute inset-0 h-full w-full object-cover opacity-50 transition-all duration-700 group-hover:opacity-60 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-l from-[#0B192C]/85 to-[#0B192C]/40" />
          <motion.div
            initial={{ opacity: 0, y: 32 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.3, ease: EASE }}
            className="relative h-full flex flex-col justify-center px-8 sm:px-14 lg:px-16 py-16"
          >
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-500 text-white transition-transform duration-500 group-hover:scale-110 group-hover:rotate-6">
              <Zap className="h-7 w-7" />
            </span>
            <p className="mt-7 text-xs font-bold uppercase tracking-[0.26em] text-blue-400">HB Charger</p>
            <h1 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-white leading-tight">
              {textos.gatewayChargerTitulo}
            </h1>
            <p className="mt-4 max-w-md text-base sm:text-lg leading-relaxed text-slate-300">
              {textos.gatewayChargerTexto}
            </p>
            <span className="mt-8 inline-flex w-fit items-center gap-2.5 rounded-full bg-blue-500 px-7 py-4 font-extrabold text-white transition-all duration-300 group-hover:bg-blue-400 group-hover:gap-4">
              Quero uma estação de recarga
              <ArrowRight className="h-5 w-5" />
            </span>
          </motion.div>
        </Link>
      </div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.6 }}
        className="relative border-t border-white/10 bg-[#0B192C] py-5 text-center text-xs font-semibold uppercase tracking-[0.22em] text-slate-500"
      >
        HB Solar · Jequié — Bahia · hbsolarenergia.com.br
      </motion.p>
    </section>
  );
}
